/**
 * The staging marker (ADR 0041): on staging.tarock.game every page shows a ribbon with the deployed commit, so a
 * tester never mistakes it for tarock.game, and the page asks search engines not to index it.
 */
import { t } from '@tarock/i18n';
import { useEffect, useState } from 'preact/hooks';
import { publicConfig } from '../auth/config';
import { site } from './site';

/** Shown on every page when the server reports `env: staging`. */
export function StagingRibbon() {
  const [sha, setSha] = useState<string | null>(null);
  useEffect(() => {
    void publicConfig().then((c) => {
      if (c?.env !== 'staging') {
        return;
      }
      setSha(c.sha.slice(0, 7));
      if (!document.querySelector('meta[name="robots"]')) {
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';
        document.head.append(meta);
      }
    });
  }, []);
  if (sha === null) {
    return null;
  }
  return (
    <div class="staging-ribbon" role="note" data-testid="staging-ribbon">
      {t('site.staging', { sha, site: site.name })}
    </div>
  );
}
